<template>
    <div>
        <van-field
                readonly
                clickable
                label="预约时间"
                placeholder="点击选择时间"
                @click="showDatePicker = true"
        >
            <template #input>
                <span class="right_input">{{ dayjs(currentDate).format('YYYY-MM-DD HH:mm') }}</span>
            </template>
        </van-field>
        <van-field
                v-model.trim="message"
                rows="10"
                autosize
                type="textarea"
                placeholder="请输入回访内容"
        />
        <div style="display: flex;align-items: center;justify-content: center;padding: 16px">
            <van-button plain type="primary" @click="goBack">返回</van-button>
            <van-button style="margin-left: 16px" type="primary" @click="save">保存</van-button>
        </div>
        <van-popup v-model="showDatePicker" position="bottom">
            <van-datetime-picker
                    v-model="currentDate"
                    type="datetime"
                    title="选择完整时间"
                    :min-date="minDate"
                    :max-date="maxDate"
                    :formatter="formatter"
                    @confirm="onConfirm"
                    @cancel="showDatePicker = false"

            />
        </van-popup>
    </div>
</template>
<script>
export default {
    components: {},
    data() {
        return {
            message: "", ExternalUserId: "",
            showDatePicker: false,
            minDate: new Date(),
            maxDate: this.dayjs().add(1, 'year').toDate(),
            currentDate: new Date(),
        }
    },
    created() {
        const route = this.$route;
        this.ExternalUserId = route.query.ExternalUserId
    },
    methods: {
        onConfirm(time) {
            this.currentDate = time;
            this.showDatePicker = false;
        },
        formatter(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } else if (type === 'month') {
                return `${val}月`;
            } else if (type === 'day') {
                return `${val}日`;
            } else if (type === 'hour') {
                return `${val}时`;
            } else if (type === 'minute') {
                return `${val}分`;
            }
            return val;
        },
        goBack() {
            this.$router.back()
        },

        async save() {
            if (!this.message || this.message.length == 0) {
                vant.Toast('请输入回访内容');
                return
            }
            await this.$dialog.confirm({
                title: "温馨提示",
                message: '是否保存回访内容？',
            });
            await this.$frame.postBusiness("WXExternalUserFollowReserv", {
                Memo: this.message,
                ExternalUserId: this.ExternalUserId,
                ReservDate: this.dayjs(this.currentDate).format('YYYY-MM-DD HH:mm'),
                UpdateFlag:'I'
            })
            this.$router.back()
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
